import { Component } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Alert } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-dashboard-assistant-card',
  imports: [NgIcon, Alert, TranslocoPipe],
  templateUrl: './dashboard-assistant-card.html',
})
export class DashboardAssistantCard {}
